export const SEGMENT_DETAIL_PARAM = "segment";
export const SEGMENTS_PAGE_SIZE = 100;
